import React from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import Menu from './Menu'
import Credentials, { selectedMenu } from '../Common/Credentials'
import { useNavigate } from 'react-router-dom'

const Layout = ({menu,children}) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = React.useState(menu || selectedMenu || 'dashboard');
    const [showUpgradeModal, setShowUpgradeModal] = React.useState(false);
    
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        Credentials.setSelectedMenu(tabId)
        navigate(`/${tabId}`);
    }

    const handleUpgradeClick = () => {
        setShowUpgradeModal(true);
    };
  return (
    <>
        <Header/>
        {/* <Sidebar activeTab={activeTab} handleTabChange={handleTabChange} setShowUpgradeModal={setShowUpgradeModal}/> */}
        <Menu/>
        <section className="content-wrapper">
        {children}
        </section>
        <div className='ml-2'>
        <Footer/>
        </div>
    </>
  )
}

export default Layout